import { render } from "./fusion360start.vue?vue&type=template&id=ef94b778&scoped=true"
import script from "./fusion360start.vue?vue&type=script&lang=js"
export * from "./fusion360start.vue?vue&type=script&lang=js"

import "./fusion360start.vue?vue&type=style&index=0&id=ef94b778&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jamesc\\source\\repos\\ul-web-plugins\\src\\UL.VueCadPlugin.Client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef94b778"]])

export default __exports__